import gql from 'graphql-tag';

export const UnifiedSpaceQuery = gql`
	query UnifiedSpaceQuery($spaceKey: String) {
		space(key: $spaceKey) {
			id
			key
			name
			type
			status
			alias
			dataClassificationTags
			didContainUserContent
			homepageId
			containsExternalCollaborators
			operations {
				operation
				targetType
			}
			currentUser {
				isAdmin
				isFavourited
				isWatched
				isAnonymouslyAuthorized
			}
			externalCollaboratorCount
			homepage {
				id
				operations {
					operation
				}
				properties(keys: ["emoji-title-published"]) {
					nodes {
						id
						key
						value
					}
				}
			}
			icon {
				path
			}
			links {
				webui
			}
			history {
				createdDate
			}
			theme {
				name
				themeKey
			}
			lookAndFeel {
				headings {
					key
					value
				}
				content {
					header {
						background
						backgroundAttachment
						backgroundBlendMode
						backgroundClip
						backgroundColor
						backgroundImage
						backgroundOrigin
						backgroundPosition
						backgroundRepeat
						backgroundSize
						borderRadius
						padding
					}
					screen {
						background
						backgroundColor
						backgroundImage
						backgroundPosition
						backgroundSize
						backgroundRepeat
						backgroundOrigin
						backgroundClip
						backgroundAttachment
						backgroundBlendMode
						layer {
							background
							backgroundColor
							backgroundImage
							backgroundPosition
							backgroundSize
							backgroundRepeat
							backgroundOrigin
							backgroundClip
							backgroundAttachment
							backgroundBlendMode
							width
							height
						}
						gutterTop
						gutterRight
						gutterBottom
						gutterLeft
					}
					container {
						background
						backgroundColor
						backgroundImage
						backgroundPosition
						backgroundSize
						backgroundRepeat
						backgroundOrigin
						backgroundClip
						backgroundAttachment
						backgroundBlendMode
						padding
						borderRadius
					}
				}
			}
			settings {
				customHeaderAndFooter {
					header {
						html
						js
						css
						spaUnfriendlyMacros {
							name
						}
					}
					footer {
						html
						js
						css
						spaUnfriendlyMacros {
							name
						}
					}
				}
			}
			spaceTypeSettings {
				enabledContentTypes {
					isBlogsEnabled
					isDatabasesEnabled
					isEmbedsEnabled
					isLivePagesEnabled
					isWhiteboardsEnabled
					isFoldersEnabled
				}
			}
		}
	}
`;
